import { performUndoableAction } from 'components/Graph/commands/history/performUndoableAction';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SetPeekingAtHiddenNodesCommand {
  peeking: boolean;
}

export const setPeekingAtHiddenNodes: GraphCommandFactory<
  SetPeekingAtHiddenNodesCommand
> = (cmdContext, dispatch) => (command) => {
  const makeUpdatePeeking = (peeking: boolean) => () => {
    cmdContext.updateState((draft) => {
      draft.peekingAtHiddenNodes = peeking;
    });
  };

  dispatch(performUndoableAction, {
    undo: makeUpdatePeeking(!command.peeking),
    redo: makeUpdatePeeking(command.peeking),
  });
};
